module.exports = __webpack_public_path__ + "static/media/dinners.a83d4e8e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/school_money/guide/dinners.svg
// module id = 592
// module chunks = 0